'use client'
import { signIn } from 'next-auth/react'
import { useEffect, useMemo, useState } from 'react'
import { useSearchParams } from 'next/navigation'
import { ChatPageSkeleton } from '@/components/chat-page-skeleton'
import { IconArchieText } from '@/components/ui/icons'
import { LoginButton } from '@/components/login-button'
import { getLogger } from 'shared/logger'
import { v4 } from 'uuid'
import { useSmokeballSdkStore } from '@/lib/store/use-smokeball-sdk-store'

export default function SmokeballSSO() {
  const [token, setToken] = useState<string>()
  const sdk = useSmokeballSdkStore((store) => store.sdk)
  const isEmbedded = useSmokeballSdkStore((store) => store.isEmbedded)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const searchParams = useSearchParams()

  const callbackUrl = searchParams.get('callbackUrl')
  const logger = useMemo(() => getLogger({ trackingId: v4(), trackingPath: `page-sign-in` }), []);

  useEffect(() => {
    async function initSdk() {
      // Only use SDK token when actually embedded in Smokeball
      if (sdk?.auth != null && isEmbedded) {
        try {
          const token = await sdk.auth.idToken()
          setToken(token)
        } catch (error) {
          logger.info('unable to get token')
        }
      }
      setIsLoading(false)
    }
    setIsLoading(true)
    initSdk()
  }, [sdk, logger, isEmbedded])

  useEffect(() => {
    if (!token) {
      return
    }
    signIn('credentials', {
      idToken: token,
      callbackUrl: callbackUrl ?? '/'
    })
  }, [token, callbackUrl])

  const adminRoute = callbackUrl && (callbackUrl.indexOf('admin') > 0 || process.env.NODE_ENV === 'development')

  if (!isLoading && !token) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        {isEmbedded ? (
          <>
            <span className="mt-2 text-lg">An error occured connecting to Archie</span>
            <span className="mt-2 text-xs text-gray-500">Couldn&apos;t get token</span>
          </>
        ) : (
          <>
            {adminRoute ? (
              <LoginButton text="Sign in with Smokeball" provider="cognito" />
            ) : (
              <IconArchieText className="h-[36px]" />
            )}
          </>
        )}
        <span className="absolute bottom-0 right-0 p-2 text-sm text-gray-500">
          v{process.env.NEXT_PUBLIC_APP_VERSION ?? "1.0.0"} {process.env.NEXT_PUBLIC_SB_ENV}-{process.env.NEXT_PUBLIC_SB_REGION}
        </span>
      </div>
    )
  }


  return <ChatPageSkeleton />
}
